import React from 'react';
import './base.scss';

const Fees = () => <div className='fees fade-in-block'>
        <h3>Fees</h3>
        <p>I charge £70 for a 50 minute session.</p>
        <p>The initial assessment sessions are also charged at £70.</p>
        <p>Fees are payable by BACS and will be invoiced at the end of each month. I ask that bills are paid within 7 days of receiving the invoice.</p>
        <p>I have a limited number of spaces for clients who are funded through BUPA or AXA Health insurance. </p>
    </div>;

export {Fees}